import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class UpdateContentService {
  private apiService = inject(ApiService);

  sendNotifications(data: any) {
    return this.apiService.store('', data);
  }
}
